export default {
  canvas: {
    name: "canvas",
    oauthName: "canvas",
    displayName: "Canvas",
  },
  classlink: {
    name: "classlink",
    oauthName: "classlink",
    displayName: "Classlink/OneRoster",
  },
  clever: {
    name: "clever",
    oauthName: "clever",
    displayName: "Clever",
  },
  google_classroom: {
    name: "google_classroom",
    oauthName: "google-oauth2",
    displayName: "Google Classroom",
  },
  native: {
    name: "native",
    oauthName: "native",
    displayName: "Newsela",
  },
  oneroster: {
    name: "oneroster",
    oauthName: "oneroster",
    displayName: "OneRoster",
  },
  schoology: {
    name: "schoology",
    oauthName: "schoology",
    displayName: "Schoology",
  },
} as const;
